import UserTable from "../Components/Users/UserTable"
const UserDashboard = () => {
  return (
    <>
      <UserTable/>
    </>
  )
}

export default UserDashboard